export default __webpack_public_path__ + "static/media/login.2a806d51.png";